import styled from "styled-components/macro";
import { Select as MuiSelect, InputLabel, FormControl } from "@mui/material";

export const StyledInputLabel = styled(InputLabel)``;

export const StyledFormControl = styled(FormControl)`
  && {
    .Mui-focused {
      color: ${({ theme }) => theme.greenMedium};
    }
  }
`;

export type SelectHeight = "Default" | "Dense";

export const StyledSelect = styled(MuiSelect).attrs({
  classes: { select: "select" },
})<{ height?: SelectHeight }>`
  && {
    .select {
      height: ${({ height }) => (height === "Dense" ? "48px" : "64px")};
      min-width: 120px;
      color: ${({ theme }) => theme.black};
      padding: 0px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
    }
  }
`;
